import { unwrapResult } from '@reduxjs/toolkit';

function buildInitiate({
  serializeQueryArgs,
  queryThunk,
  mutationThunk,
  api
}) {
  const {
    unsubscribeQueryResult,
    unsubscribeMutationResult,
    updateSubscriptionOptions
  } = api.internalActions;
  return {
    buildInitiateQuery,
    buildInitiateMutation
  };

  function buildInitiateQuery(endpoint, definition) {
    const queryAction = (arg, {
      subscribe = true,
      forceRefetch,
      subscriptionOptions
    } = {}) => (dispatch, getState) => {
      const internalQueryArgs = definition.query(arg);
      const queryCacheKey = serializeQueryArgs({
        queryArgs: arg,
        internalQueryArgs,
        endpoint
      });
      const thunk = queryThunk({
        subscribe,
        forceRefetch,
        subscriptionOptions,
        endpoint,
        originalArgs: arg,
        internalQueryArgs,
        queryCacheKey,
        startedTimeStamp: Date.now()
      });
      const thunkResult = dispatch(thunk);
      const {
        requestId,
        abort
      } = thunkResult;
      const statePromise = thunkResult.then(() => api.endpoints[endpoint].select(arg)(getState()));
      return Object.assign(statePromise, {
        arg,
        requestId,
        abort,

        refetch() {
          dispatch(queryAction(arg, {
            subscribe: false,
            forceRefetch: true
          }));
        },

        unsubscribe() {
          if (subscribe) dispatch(unsubscribeQueryResult({
            queryCacheKey,
            requestId
          }));
        },

        updateSubscriptionOptions(options) {
          dispatch(updateSubscriptionOptions({
            endpoint,
            requestId,
            queryCacheKey,
            options
          }));
        }

      });
    };

    return queryAction;
  }

  function buildInitiateMutation(endpoint, definition) {
    return (arg, {
      track = true
    } = {}) => (dispatch, getState) => {
      const internalQueryArgs = definition.query(arg);
      const thunk = mutationThunk({
        endpoint,
        internalQueryArgs,
        originalArgs: arg,
        track,
        startedTimeStamp: Date.now()
      });
      const thunkResult = dispatch(thunk);
      const {
        requestId,
        abort
      } = thunkResult;
      const returnValuePromise = thunkResult.then(unwrapResult).then(unwrapped => ({
        data: unwrapped.result
      })).catch(error => ({
        error
      }));
      return Object.assign(returnValuePromise, {
        arg: thunkResult.arg,
        requestId,
        abort,

        unwrap() {
          return thunkResult.then(unwrapResult).then(unwrapped => unwrapped.result);
        },

        unsubscribe() {
          if (track) dispatch(unsubscribeMutationResult({
            requestId
          }));
        }

      });
    };
  }
}

export { buildInitiate };
//# sourceMappingURL=buildInitiate.js.map
